// config/ipfs.js
// IPFS Configuration for different providers

// Option 1: Pinata Configuration
export const PINATA_CONFIG = {
    fileUploadURL: 'https://api.pinata.cloud/pinning/pinFileToIPFS',
    jsonUploadURL: 'https://api.pinata.cloud/pinning/pinJSONToIPFS',
    apiKey: "5848c198ddbbcdfb9d3e",
    secretKey: "bf3e12c5cfe9b6da4a3076ea809b989272ca7596677e95628e20d78e24d3483f",
    gateway: 'https://gateway.pinata.cloud/ipfs/',
};

// Option 2: Web3.Storage Configuration
export const WEB3_STORAGE_CONFIG = {
    uploadURL: 'https://api.web3.storage/upload',
    token: process.env.REACT_APP_WEB3_STORAGE_TOKEN,
    gateway: 'https://w3s.link/ipfs/',
};

// Option 3: NFT.Storage Configuration
export const NFT_STORAGE_CONFIG = {
    uploadURL: 'https://api.nft.storage/upload',
    token: process.env.REACT_APP_NFT_STORAGE_TOKEN,
    gateway: 'https://nftstorage.link/ipfs/',
};
export const IPSF_NODE = "https://ipfs.tizzew.com/ipfs/";

export const getIpfsNode = (url) => {
    // console.log(url , 'url in getIpfsNode');
  if (!url) return null;
    // console.log("https://ipfs.tizzew.com/ipfs/" + url.replace(/^ipfs:\/\//, ""), 'url in getIpfsNode');
  
    return "https://ipfs.tizzew.com/ipfs/" + url.replace(/^ipfs:\/\//, "");
};
// Environment variables needed in .env file:
/*
# For Pinata
REACT_APP_PINATA_API_KEY=your_pinata_api_key
REACT_APP_PINATA_SECRET_KEY=your_pinata_secret_key

# For Web3.Storage
REACT_APP_WEB3_STORAGE_TOKEN=your_web3_storage_token

# For NFT.Storage
REACT_APP_NFT_STORAGE_TOKEN=your_nft_storage_token
*/

// Example implementation for Pinata
export const uploadToPinata = {
    uploadFile: async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(PINATA_CONFIG.fileUploadURL, {
            method: 'POST',
            headers: {
                'pinata_api_key': PINATA_CONFIG.apiKey,
                'pinata_secret_api_key': PINATA_CONFIG.secretKey,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Pinata file upload failed: ${response.statusText}`);
        }

        const result = await response.json();
        return result.IpfsHash;
    },

    uploadJSON: async (jsonData) => {
        const response = await fetch(PINATA_CONFIG.jsonUploadURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pinata_api_key': PINATA_CONFIG.apiKey,
                'pinata_secret_api_key': PINATA_CONFIG.secretKey,
            },
            body: JSON.stringify({
                pinataContent: jsonData,
                pinataMetadata: {
                    name: `pool-metadata-${Date.now()}`,
                },
            }),
        });

        if (!response.ok) {
            throw new Error(`Pinata JSON upload failed: ${response.statusText}`);
        }

        const result = await response.json();
        return result.IpfsHash;
    },
};

// Example implementation for Web3.Storage
export const uploadToWeb3Storage = {
    uploadFile: async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(WEB3_STORAGE_CONFIG.uploadURL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${WEB3_STORAGE_CONFIG.token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Web3.Storage upload failed: ${response.statusText}`);
        }

        const result = await response.json();
        return result.cid;
    },

    uploadJSON: async (jsonData) => {
        const blob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });
        const formData = new FormData();
        formData.append('file', blob, 'metadata.json');

        const response = await fetch(WEB3_STORAGE_CONFIG.uploadURL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${WEB3_STORAGE_CONFIG.token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Web3.Storage JSON upload failed: ${response.statusText}`);
        }

        const result = await response.json();
        return result.cid;
    },
};